import { StyleSheet } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColor,
    paddingTop: 35,
    paddingBottom: isIPhoneWithNotch ? 55 : 35,
    paddingHorizontal: 16.2,
    justifyContent: 'space-between',
  }),
  contentStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  titleStyle: theme => ({
    ...Fonts.type.bold,
    color: theme.colors.textColorThree,
    fontSize: 24,
    marginBottom: 20,
    lineHeight: 31.2,
  }),
  descriptionStyle: {
    fontSize: 16,
    color: Colors.thinDark,
    lineHeight: 21,
    textAlign: 'center',
  },
  subTitleStyle: {
    fontSize: 16,
    lineHeight: 20,
    marginHorizontal: 9,
    textAlign: 'center',
    marginTop: 19,
  },
  primaryButtonStyle: {
    marginBottom: 17.1,
  },
  buttonStyle: {
    width: '100%',
  },
});
